import {
  types,
  IDisplayNotificationAction,
  ICloseNotificationAction,
  INotificationTrigger,
} from '../types/notifications'

// The triggerNotification action is used to trigger display/close notification cycle
// Both displayNotification and closeNotification actions are used only inside notifications sagas
export const displayNotification = (
  message: string,
  correlationId?: string
): IDisplayNotificationAction => ({
  type: types.NOTIFICATION_DISPLAY,
  message,
  correlationId,
})

export const closeNotification = (): ICloseNotificationAction => ({
  type: types.NOTIFICATION_CLOSE,
})

export const triggerNotification = (message: string): INotificationTrigger => ({
  type: types.NOTIFICATION_TRIGGER,
  message,
})
